import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { ReactComponent as BrandAstraLightLogo } from '../../../assests/images/LandingAssets/BrandAstraLightLogo.svg';
import { useLocation, useNavigate } from 'react-router-dom';

const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '1800px',
};

export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};
const FooterContainer = styled.footer`
  background: linear-gradient(99.96deg, #063257 0.95%, #006867 99.05%);
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Inter;
  min-height: 200px;
  text-align: left;
  padding-top: 120px;
  padding-bottom: 120px;
  width: 100%;
  @media only screen and ${device.tablet} {
    min-height: 754px;
  }
`;

const LogoSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const Copyright = styled.p`
  margin-top: 200px;
  font-weight: 400;
  font-size: 15px;

  letter-spacing: 5%;
  color: #fafafa;
  @media only screen and ${device.tablet} {
    display: none;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const ColumnTitle = styled.h3`
  font-weight: 400;
  font-size: 20px;

  color: #fafafa;
`;

const Link = styled.div`
  font-weight: 400;
  font-size: 16px;
  margin-top: 10px;

  color: #b4b4b4;
  text-decoration: ${(props) => (props?.contact ? 'underline' : 'none')};
  &:hover {
    color: #ffffff;
    text-decoration: underline;
    cursor: pointer;
  }
`;
const ColumnContainer = styled.div`
  display: flex;
  gap: 100px;
  @media only screen and ${device.tablet} {
    width: 345px;
    flex-wrap: wrap;
    gap: 60px;
    margin-top: 60px;
  }
`;

const Container = styled.div`
  width: 1140px;
  display: flex;
  justify-content: space-between;
  @media only screen and ${device.tablet} {
    flex-direction: column;
    width: 345px;
  }
`;
const CopyrightMobile = styled.div`
  font-weight: 400;
  font-size: 15px;

  letter-spacing: 5%;
  color: #fafafa;
  display: none;
  @media only screen and ${device.tablet} {
    display: block;
    margin-top: 100px;
  }
`;

const SocialMediaLink = styled.a`
  font-weight: 400;
  font-size: 16px;
  margin-top: 10px;

  color: #b4b4b4;
  text-decoration: ${(props) => (props?.contact ? 'underline' : 'none')};
  &:hover {
    color: #ffffff;
    text-decoration: underline;
    cursor: pointer;
  }
`;

const LogoText = styled.div`
  font-weight: 400;
  font-size: 16px;
  color: #b4b4b4;
`;
const LandingFooter = () => {
  let navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (section) => {
    let anchor = '';
    if (
      location.pathname?.includes('book-a-demo') ||
      location.pathname?.includes('resources') ||
      location.pathname?.includes('blog') ||
      location.pathname?.includes('pricing')
    ) {
      navigate('/', { state: { section } });
      setTimeout(() => {
        anchor = document.querySelector(`#${section}`);
        if (anchor) {
          anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 300); // A
    } else {
      if (section === 'what-do-we-do') {
        anchor = document.querySelector('#what-do-we-do');
      } else if (section === 'solutions') {
        anchor = document.querySelector('#solutions');
      } else if (section === 'pricing') {
        anchor = document.querySelector('#pricing');
      } else if (section === 'impact') {
        anchor = document.querySelector('#impact');
      } else if (section === 'faq') {
        anchor = document.querySelector('#faq');
      } else {
        anchor = document.querySelector('#what-do-we-do');
      }
      setTimeout(() => {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }
  };
  return (
    <FooterContainer>
      <Container>
        <LogoSection>
          <div style={{ marginTop: '12px' }}>
            <BrandAstraLightLogo height={'60px'} width={'300px'} />
            <LogoText>Innovated by Copperpod.AI</LogoText>
          </div>
          <Copyright>© 2025 BrandAstra. All Rights Reserved.</Copyright>
        </LogoSection>
        <ColumnContainer>
          <Column>
            <ColumnTitle>QUICK LINKS</ColumnTitle>
            <Link
              onClick={() => {
                scrollToSection('what-do-we-do');
              }}
            >
              Solutions
            </Link>
            <Link
              onClick={() => {
                scrollToSection('impact');
              }}
            >
              Impact
            </Link>
            <Link onClick={() => navigate('/pricing')}>Pricing</Link>
            <Link
              onClick={() => {
                navigate('/resources');
              }}
            >
              Resources
            </Link>
            <Link
              onClick={() => {
                scrollToSection('faq');
              }}
            >
              FAQs
            </Link>
          </Column>

          <Column>
            <ColumnTitle>LEGAL</ColumnTitle>
            <Link
              onClick={() => {
                navigate('/policy');
              }}
            >
              Privacy Policy
            </Link>
            <Link
              onClick={() => {
                navigate('/terms');
              }}
            >
              Terms of Service
            </Link>
          </Column>

          <Column>
            <ColumnTitle>CONTACT</ColumnTitle>
            <SocialMediaLink
              contact={true}
              href='https://www.linkedin.com/company/brandastra-ai'
              target='_blank'
            >
              LinkedIn
            </SocialMediaLink>
            <SocialMediaLink
              contact={true}
              href='https://x.com/Brandastra_ai'
              target='_blank'
            >
              X
            </SocialMediaLink>
            <SocialMediaLink
              contact={true}
              target='_blank'
              href='https://www.instagram.com/brandastra_ai/'
            >
              Instagram
            </SocialMediaLink>
            <SocialMediaLink
              target='_blank'
              contact={true}
              href='https://www.youtube.com/@brandastra_ai'
            >
              YouTube
            </SocialMediaLink>
            <SocialMediaLink
              target='_blank'
              contact={true}
              href='https://in.pinterest.com/brandastraai/'
            >
              Pinterest
            </SocialMediaLink>
          </Column>
        </ColumnContainer>
        <CopyrightMobile>
          © 2025 BrandAstra. All Rights Reserved.
        </CopyrightMobile>
      </Container>
    </FooterContainer>
  );
};

export default LandingFooter;
